angular
    .module('userNotifications.v1')
    .directive('pendingReviewCount', pendingReviewCount);

/**
 * @ngdoc directive
 * @name userNotifications.v1.directive:pendingReviewCount
 * @restrict A
 * @element any
 *
 * @description
 * Displays the count of all jobs marked as "pending review"
 *
 * #### Script file
 * - `/web3/build/storefront/widgets/pending-review-count.v1.directive.js`
 *
 * #### Classes
 * - `isPending` : applied while notifications are in the proces of loading
 * - `isEmpty` : applied when the total notification count is 0
 *
 * #### Events
 * - `window.events.PENDING_REVIEW_LIST_UPDATED` : raised whenever the notification count changes
 *
 * @example
    <pre>
        <!-- load widget script -->
        <script src="/web3/build/storefront/widgets/pending-review-count.v1.directive.js"></script>

        <!-- display widget count -->
        <span pending-review-count></span>

        <!-- respond to events -->
        <script>
            window.events.listen(window.events.PENDING_REVIEW_LIST_UPDATED, function () {
                console.log('pending review count updated');
            });
        </script>
    </pre>
    */

pendingReviewCount.$inject = [];

function pendingReviewCount () {
    return {
        restrict: 'A',
        template: '<span ng-bind="pendingReviewCountController.count"></span>',
        link: function pendingReviewCountDirective_linkFn (scope, element, attrs, controller, transclude) {},
        controller: PendingReviewCountController,
        controllerAs: 'pendingReviewCountController',
        bindToController: true,
        scope: {}
    };
};

PendingReviewCountController.$inject = ['$scope', '$element', 'userNotificationsService', 'authService', '$timeout'];

function PendingReviewCountController ($scope, $element, userNotificationsService, authService, $timeout) {
    var vm = this;

    vm.count = 0;

    init();

    return;

    function init () {
        $element
            .addClass('isEmpty')
            .addClass('isPending');
        // Subscribe to auth changes
        authService.subscribe($scope, handleAuthChange);
        // Subscribe to pendingReviewItems updates
        userNotificationsService.pendingReviewItems.subscribe($scope, handlePendingReviewItemsUpdate);
        // Subscribe to classic events
        userNotificationsService.classicEvents.subscribe($scope, getPendingReviewItems);
        // Initial loading of pendingReviewItems
        getPendingReviewItems();
    }

    function handleAuthChange ($event, user) {
        if (!authService.isLoggedIn()) {
            return resetDirective();
        }

        getPendingReviewItems();
    }

    function getPendingReviewItems () {
        if (!authService.isLoggedIn()) {
            return resetDirective();
        }

        userNotificationsService.pendingReviewItems.get(authService.getUser().id);
    }

    function handlePendingReviewItemsUpdate ($event, reviewItems) {
        if (!reviewItems) {
            return resetDirective();
        }

        if (!reviewItems.length) {
            $element.addClass('isEmpty');
        } else {
            $element.removeClass('isEmpty');
        }

        $timeout(function(){
            vm.count = reviewItems.length;
        });
        $element
            .show()
            .removeClass('isPending');
    }

    function resetDirective () {
        vm.count = 0;
        $element
            .hide()
            .addClass('isEmpty')
            .removeClass('isPending');
    }
};